import { T_KeyValue } from "@/types/app.type";
import { isEmptyObject, strToBool, validPageSlugs } from "./utils.helper";
import { ContentfulClientApi, createClient } from "contentful";
import { CAT, CONTENTFUL_ENV, CONTENTFUL_SPACE_ID, APP_TAG_ID, BASEPLATE_APP_CONFIG, getDefaultLocale, CPAT } from '@/config/app.config';
import { getData } from "@/actions/page.action";
import { T_ExperienceVariable } from "@/types/experiences";

export const inBuiltStyles: T_KeyValue = {
    horizontalAlignment: 'cfHorizontalAlignment',
    verticalAlignment: 'cfVerticalAlignment',
    margin: 'cfMargin',
    padding: 'cfPadding',
    backgroundColor: 'cfBackgroundColor',
    width: 'cfWidth',
    maxWidth: 'cfMaxWidth',
    height: 'cfHeight',
    flexDirection: 'cfFlexDirection',
    flexWrap: 'cfFlexWrap',
    border: 'cfBorder',
    borderRadius: 'cfBorderRadius',
    gap: 'cfGap',
    hyperlink: 'cfHyperlink',
    fontSize: 'cfFontSize',
    fontWeight: 'cfFontWeight',
    lineHeight: 'cfLineHeight',
    letterSpacing: 'cfLetterSpacing',
    textColor: 'cfTextColor',
    textAlign: 'cfTextAlign',
    textTransform: 'cfTextTransform',
    textBold: 'cfTextBold',
    textItalic: 'cfTextItalic',
    textUnderline: 'cfTextUnderline',
    openInNewTab: 'cfOpenInNewTab',
    columns: 'cfColumns',
    columnSpan: 'cfColumnSpan',
    columnSpanLock: 'cfColumnSpanLock',
    wrapColumns: 'cfWrapColumns',
    wrapColumnsCount: 'cfWrapColumnsCount',
    visibility: 'cfVisibility'
};

export const setAttr = ({ displayName = "", tooltip, type = "Text", defaultValue, description = "", validations, group = "style" }: T_ExperienceVariable) => {
    return {
        displayName,
        type,
        ...(() => { return defaultValue ? { defaultValue: defaultValue } : {} })(),
        ...(() => { return tooltip ? { tooltip: tooltip } : {} })(),
        ...(() => { return description ? { description: description } : {} })(),
        // ...(()=>{return defaultValue || {}})(),
        // ...(()=>{return description || {}})(),

        ...(() => { return (Array.isArray(validations?.in)) ? { validations: { in: validations?.in } } : {} })(),
        // ...(() => {
        //     return (validations || {in: []}) ?? group === "style" ? {
        //         validations: {
        //             in: (Array.isArray(validations) && validations?.length > 0) ? (
        //                 validations?.map((obj: T_KeyValue) => {
        //                     if (!obj?.displayName) {
        //                         obj["displayName"] = toSentenceCase(obj?.value)
        //                     }
        //                     return obj;
        //                 })
        //             ) : (
        //                 typeof (validations) === 'object' ? (
        //                     validations?.in?.map((obj: T_KeyValue) => {
        //                         if (!obj?.displayName) {
        //                             obj["displayName"] = toSentenceCase(obj?.value)
        //                         }
        //                         return obj;
        //                     })
        //                 ) : {})

        //         }
        //     } : {}
        // })(),


        group
    }
}

export const deliveryClient: ContentfulClientApi<undefined> = (() => {
    if (CONTENTFUL_SPACE_ID && CAT) {
        return createClient({
            space: CONTENTFUL_SPACE_ID,
            accessToken: CAT,
            environment: CONTENTFUL_ENV || "",
            // Disable env-proxy resolution to avoid Node url.parse deprecation warnings in dev.
            proxy: false,
        })
    } else { return ({} as ContentfulClientApi<undefined>); }
})();

export const previewClient: ContentfulClientApi<undefined> = (() => {
    if (CONTENTFUL_SPACE_ID && CPAT) {
        return createClient({
            space: CONTENTFUL_SPACE_ID,
            accessToken: CPAT,
            environment: CONTENTFUL_ENV || "",
            // Disable env-proxy resolution to avoid Node url.parse deprecation warnings in dev.
            proxy: false,
            // host: 'preview.contentful.com'
        })
    } else { return ({} as ContentfulClientApi<undefined>); }
})();

// export const getBaseplateConfig = async ({ searchParams, host, slug="/", isEnabled=false }: { searchParams: Promise<{ [key: string]: any }>, host: string, slug: string|undefined, isEnabled?: boolean }) => {
//     const { slug: searchSlug, environment, expEnabled } = await searchParams;
//     // debugger;
//     const baseplateAppConfig: any = await getData({ tags: BASEPLATE_APP_CONFIG, preview: isEnabled });
//     const domainConfig: T_DomainConfig  = baseplateAppConfig?.items[0]?.content?.appConfig?.domains?.[host];
//     // if(!domainConfig) { return { baseplateAppConfig, appCnf, domainConfig }}

//     const appCnf: {
//         environment?: string;
//         expSlug?: string;
//         expEnabled?: boolean;
//         tags?: string;
//     } = (() => {
//         const segment = domainConfig?.routes?.[slug || "/"];
//         if (typeof (segment) === "string") {
//             // redirection = true;
//             return { tags: segment };
//         } else if (typeof (segment) === "object") {
//             return {
//                 ...segment,
//                 ...(expEnabled ? { expEnabled: strToBool(expEnabled) } : {}),
//                 ...(searchSlug ? { expSlug: searchSlug } : {}),
//                 ...(environment ? { environment: environment } : {})
//             };
//         } else {
//             return { tags: APP_TAG_ID };
//         }
//     })();
//     return { baseplateAppConfig, appCnf, domainConfig }
// }

export async function setDomainCookies(cookieStore: CookieStore, domainConfig: any) {
    if (!cookieStore) return; // Early exit if unsupported

    const cookies = [
        { name: "BP_INITIATIVE", value: domainConfig?.initiative },
        { name: "BP_THEME", value: domainConfig?.theme },
        { name: "BP_MP_ID", value: domainConfig?.meetingPlaceId },
        { name: "BP_MP_NAME", value: domainConfig?.meetingPlaceName },
        { name: "BP_DOMAIN", value: domainConfig?.domainName }, // Fixed typo
        { name: "market", value: domainConfig?.market || domainConfig?.country || domainConfig?.locale?.default }
    ];

    try {
        await Promise.all(
            cookies.map(({ name, value }) => 
                (cookieStore && value != null) ? cookieStore?.set({ name, value, path: '/' }) : null // Add path for reliability
            )
        );
        console.log('All cookies set successfully');
    } catch (error) {
        console.error('Failed to set cookies:', error);
    }
}

export const fetchBaseplateConfig = async ({
    environment,
    host,
    pathname,
    slug = "/",
    expSlug,
    expEnabled,
    isEnabled = false,
    localeListFallback,
    paramSlug,
    origin,
    draftModeEnabled,
    cookieStore }: {
        environment: string | null,
        pathname: string | null,
        host: string,
        slug: string | null,
        expSlug: string | null,
        expEnabled: string | null,
        isEnabled?: boolean,
        paramSlug?: string | string[] | null,
        localeListFallback?: string | null,
        origin?: string | null,
        draftModeEnabled?: boolean,
        cookieStore?: any
    }) => {
    // const { slug: searchSlug, environment, expEnabled } = await searchParams;
    // // debugger;
    // const baseplateAppConfig: any = await getData({ tags: BASEPLATE_APP_CONFIG, preview: isEnabled });
    // const domainConfig: T_DomainConfig  = baseplateAppConfig?.items[0]?.content?.appConfig?.domains?.[host];
    // // if(!domainConfig) { return { baseplateAppConfig, appCnf, domainConfig }}

    // const appCnf: {
    //     environment?: string;
    //     expSlug?: string;
    //     expEnabled?: boolean;
    //     tags?: string;
    // } = (() => {
    //     const segment = domainConfig?.routes?.[slug || "/"];
    //     if (typeof (segment) === "string") {
    //         // redirection = true;
    //         return { tags: segment };
    //     } else if (typeof (segment) === "object") {
    //         return {
    //             ...segment,
    //             ...(expEnabled ? { expEnabled: strToBool(expEnabled) } : {}),
    //             ...(searchSlug ? { expSlug: searchSlug } : {}),
    //             ...(environment ? { environment: environment } : {})
    //         };
    //     } else {
    //         return { tags: APP_TAG_ID };
    //     }
    // })();
    // return { baseplateAppConfig, appCnf, domainConfig }

    // console.log("getBaseplateConfig step 1 ---- ", { environment,
    // host,
    // pathname,
    // slug,
    // expSlug,
    // expEnabled,
    // isEnabled,
    // localeListFallback,
    // paramSlug,
    // origin,
    // draftModeEnabled,
    // cookieStore  });

    // console.log("AppConfig start ---- ", (new Date()).getTime())

    console.log("getBaseplateConfig step 1.0 ---- ", { origin, slug, paramSlug, localeListFallback, draftModeEnabled, expSlug, expEnabled, environment, host, pathname });
    const baseplateAppConfigResp: any = await getData({ tags: BASEPLATE_APP_CONFIG, preview: draftModeEnabled });
    console.log("getBaseplateConfig step 1.1 ---- ", { origin });
    const baseplateAppConfigContent: any = baseplateAppConfigResp?.items[0]?.content;
    console.log("getBaseplateConfig step 1.2 ---- ", { origin });
    const baseplateMasterAppConfig: any = baseplateAppConfigContent?.appConfig;
    console.log("getBaseplateConfig step 1.3 ---- ", { origin });
    const hostAndEntryId: string = baseplateAppConfigContent?.initiativesEntryIds?.find((ieid: string) => ieid.includes(`${host}|`)); //`${'digitalbaseplatedev.azurewebsites.net'}|`
    console.log("getBaseplateConfig step 1.4 ---- ", { origin, hostAndEntryId });
    const hostAndEntryIdArr = hostAndEntryId?.split('|');
    console.log("getBaseplateConfig step 1.4 ---- ", { origin, hostAndEntryId, length: hostAndEntryIdArr?.length, host: hostAndEntryIdArr?.[0], EntryId: hostAndEntryIdArr?.[1] });
    const baseplateSubAppConfigResp: any = hostAndEntryId && hostAndEntryIdArr?.length > 0 && hostAndEntryIdArr?.[1] ? await getData({ id: (hostAndEntryIdArr[1] as string), preview: draftModeEnabled }) : null;
    console.log("getBaseplateConfig step 1.5 ---- ", { origin });
    const baseplateSubAppConfigContent = baseplateSubAppConfigResp?.items?.[0]?.content;
    console.log("getBaseplateConfig step 1.6 ---- ", { origin });
    const baseplateSubAppConfig: any = baseplateSubAppConfigContent?.appConfig;

    // console.log("getBaseplateConfig step 2 ---- ", { 
    //     origin, 
    //     // baseplateSubAppConfigContent, 
    //     baseplateSubAppConfig 
    // });

    console.log("getBaseplateConfig ----- ", { BASEPLATE_APP_CONFIG, draftModeEnabled, initiativesEntryIds: baseplateAppConfigContent?.initiativesEntryIds})

    // console.log("AppConfig mid ---- ", (new Date()).getTime())
    // const baseplateAppConfig = baseplateAppConfigResp;
    const baseplateAppConfig = await (async ()=>({
        ...baseplateAppConfigResp,
        items: [
            {
                ...baseplateAppConfigResp?.items?.[0],
                content: {
                    ...(() => {
                        if (!baseplateAppConfigResp?.items?.[0]?.content || isEmptyObject(baseplateAppConfigResp?.items?.[0]?.content)) return {};
                        const { initiativesEntryIds, ...finalContentObj } = baseplateAppConfigResp?.items?.[0]?.content;
                        return finalContentObj;
                    })(),
                    appConfig: {
                        "domains": await (async () => {
                            let bpMasterAppConfig = {};
                            if (baseplateMasterAppConfig?.hasOwnProperty("domains")) {
                                bpMasterAppConfig = baseplateMasterAppConfig?.["domains"]?.[host];
                            }

                            // console.log("getBaseplateConfig step 3 ---- ", { origin });
                            // console.log("getBaseplateConfig 2 ----- ", host, bpMasterAppConfig)
                            return {
                                [host]: {
                                    ...(bpMasterAppConfig || {}),
                                    ...(baseplateSubAppConfig || {}),
                                    ...(baseplateSubAppConfigContent?.favicon ? { favicon: baseplateSubAppConfigContent?.favicon } : {}),
                                    ...(baseplateSubAppConfigContent?.oneTrust ? { oneTrust: baseplateSubAppConfigContent?.oneTrust } : {}),
                                    ...((baseplateSubAppConfigContent?.theme || baseplateAppConfigContent?.theme) ? { theme: baseplateSubAppConfigContent?.theme || baseplateAppConfigContent?.theme } : { theme: "custom" }),
                                    ...(baseplateSubAppConfigContent?.initiativeName ? { initiative: baseplateSubAppConfigContent?.initiativeName } : {}),
                                    ...((baseplateSubAppConfigContent?.localeList || baseplateAppConfigContent?.localeList || baseplateSubAppConfigContent?.defaultLocale || baseplateAppConfigContent?.defaultLocale) ? {
                                        locale: {
                                            list: baseplateSubAppConfigContent?.localeList || baseplateAppConfigContent?.localeList || ["en"],
                                            default: baseplateSubAppConfigContent?.defaultLocale || baseplateAppConfigContent?.defaultLocale || "en"
                                        }
                                    } : {}),
                                    ...((baseplateSubAppConfigContent?.gtmId
                                        || baseplateSubAppConfigContent?.gaId
                                        || baseplateAppConfigContent?.gtmId
                                        || baseplateAppConfigContent?.gaId
                                        || baseplateSubAppConfigContent?.consoleMeta
                                        || baseplateAppConfigContent?.consoleMeta) ? {
                                        google: {
                                            gtmId: baseplateSubAppConfigContent?.gtmId || baseplateAppConfigContent?.gtmId || "",
                                            gaId: baseplateSubAppConfigContent?.gaId || baseplateAppConfigContent?.gaId || "",
                                            consoleMeta: baseplateSubAppConfigContent?.consoleMeta || baseplateAppConfigContent?.consoleMeta || ""
                                        }
                                    } : {})
                                }
                            }
                        })()
                    }
                }
            }
        ]
    }))()

    await (async () => setTimeout(() => { }, 10))();
    // console.log("getBaseplateConfig step 4 ---- ", { origin });
    const domainConfig: any = baseplateAppConfig?.items[0]?.content?.appConfig?.domains?.[host]; //baseplateMasterAppConfig; //baseplateAppConfig?.items[0]?.content?.appConfig?.domains?.[host]; //baseplateAppConfig?.items[0]?.content?.appConfig?.domains?.[host] //baseplateAppConfig?.domains[host]; //baseplateAppConfig?.items[0]?.content?.appConfig?.domains[host];

    // if(cookieStore) { await setDomainCookies(cookieStore, domainConfig); }

    await (async () => setTimeout(() => { }, 10))();

    const appCnf: T_KeyValue = (expEnabled || expSlug || environment) ? await (async () => {
        const segment: { [key: string]: string | boolean } | string = domainConfig?.routes?.[(pathname ? (pathname?.split("/")?.[1]) : (slug && !slug?.includes("appspecific") ? slug : "/")) as string];
        if (segment && typeof (segment) === "string") {
            // redirection = true;
            return { tags: segment };
        } else if (segment && typeof (segment) === "object") {
            return {
                ...(segment || {}),
                ...(expEnabled ? { expEnabled: strToBool(expEnabled as string) } : {}),
                ...(expSlug ? { expSlug: expSlug } : {}),
                ...(environment ? { environment: environment } : {})
            };
        } else {
            return { tags: APP_TAG_ID };
        }
    })() : {};

    const localeList = await domainConfig?.locale?.list || (localeListFallback ? [(getDefaultLocale())] : []);
    const defaultLocale = await domainConfig?.locale?.default || (localeListFallback ? getDefaultLocale() : undefined);
    const pageSlugs = await validPageSlugs({ routes: Object.keys(domainConfig?.routes || {}), paramSlug: paramSlug || [] })

    await (async () => setTimeout(() => { }, 10))();
    const rt = {
        appCnf,
        domainConfig: domainConfig,
        localeList: localeList,
        defaultLocale: defaultLocale,
        pageSlugs: pageSlugs
    };

    // console.log("AppConfig end ---- ", (new Date()).getTime());
    // globalThis.__bp_cache__ = rt; // cached safely

    console.log("getBaseplateConfig step 7 ---- ", { origin, ...rt, baseplateAppConfigResp, baseplateAppConfig: JSON.stringify(baseplateAppConfig, null, 2), ll: domainConfig?.locale?.list, dl: domainConfig?.locale?.default });
    // console.log("getBaseplateConfig 3 ----- ", host, domainConfig, appCnf)
    return {
        baseplateAppConfig,
        ...rt
    }
}